// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_5b986360","image":"_80c81e94","placeholder":"_476cf0d0","moduleWrapper":"_20917e3a","module":"_32541ba9","title":"_439b6d93","subtitle":"_3028c357","button":"_ecf60de5"};